import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Resources/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ResourcesQueries extends VueCqrs
{
	runResourcesByStrategyIdQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildResourcesByStrategyIdQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runResourceUnitCostsQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildResourceUnitCostsQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runResourceCapacityPageQueryV1(workspaceId: number, strategyId: string, resourceId: string)
	{
		const query = q.buildResourceCapacityPageQueryV1(workspaceId, strategyId, resourceId);
		this.$query(query);
	}
}